module.exports = __webpack_public_path__ + "static/img/pc-web-img-05@m.f38c0e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/premium-food-market/pc-web-img-05@m.png
// module id = lK/G
// module chunks = 0